module.exports = __webpack_public_path__ + "static/media/reject.e1b9e6ad.png";